// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k4-1";
export var messageSideRight = "_k4-2";
export var subscribeToBackInStockBubbleContainer = "_k4-0";